module.exports = __webpack_public_path__ + "img/back-bottom-left2.86954266.png";